import {
  DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_BEGIN,
  DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_SUCCESS,
  DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_FAILURE,
  DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
export function loadEventsExternalDataSource(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_BEGIN,
    });
    const { projectId, version, externalDatabaseId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);

    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/events`;
      if (externalDatabaseId) {
        url += `?externalDatabaseId=${externalDatabaseId}`;
      }
      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadEventsExternalDataSourceError() {
  return {
    type: DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_BEGIN:
      return {
        ...state,
        loadEventsExternalDataSourcePending: true,
        loadEventsExternalDataSourceError: null,
      };

    case DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_SUCCESS:
      return {
        ...state,
        loadEventsExternalDataSourcePending: false,
        loadEventsExternalDataSourceError: null,
        eventsExternalDataSources: action.data,
      };

    case DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_FAILURE:
      return {
        ...state,
        loadEventsExternalDataSourcePending: false,
        loadEventsExternalDataSourceError: action.data.error,
      };

    case DATA_CONNECTOR_LOAD_EVENTS_EXTERNAL_DATA_SOURCE_DISMISS_ERROR:
      return {
        ...state,
        loadEventsExternalDataSourceError: null,
      };

    default:
      return state;
  }
}
